import { fetchWithAuth } from '@shared/utils/auth';
import { backendUrl } from '@shared/constants/urls/appUrls';

//------------------------------------------------------------------------------
//              Отправить запрос на получение списка комментариев
//------------------------------------------------------------------------------
export const toGetCommentsList = async (idPost, area) => {
  const isSignal = (area === 'signal') ? '&type=signal' : '';
  const url = `${ backendUrl }/api/comments/${idPost}/?limit=500&offset=0${isSignal}`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении списка комментариев: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch (error) {
    console.error('Ошибка получения списка комментариев: Error fetching get comments list:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

//------------------------------------------------------------------------------
//          Отправить запрос на получение следующей страницы комментариев
//------------------------------------------------------------------------------
export const toGetNextCommentsList = async (next) => {
  const url = `${ next }`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении списка комментариев: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch (error) {
    console.error('Ошибка получения списка комментариев: Error fetching get comments list:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx